import { render, staticRenderFns } from "./TamamlanmayanTakipList.vue?vue&type=template&id=008c424c&scoped=true"
import script from "./TamamlanmayanTakipList.vue?vue&type=script&lang=ts"
export * from "./TamamlanmayanTakipList.vue?vue&type=script&lang=ts"
import style0 from "./TamamlanmayanTakipList.vue?vue&type=style&index=0&id=008c424c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008c424c",
  null
  
)

export default component.exports